export default __webpack_public_path__ + "locales/ar-SA/ChangePasswordDialog.json?hash=935bb60685aa63052ed9835437a9d8a8";